"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FooterLoader = void 0;
var _footer = require("@ori/footer");
var _logger = require("@ori/logger");
var _react = _interopRequireWildcard(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); } /*
 * This wrapper ensures that even with an error in the Footer.tsx file, the rest of the page
 * will still render and this will show skeleton. This will also show skeleton while loading Footer.tsx file.
 */
const Footer = /*#__PURE__*/(0, _react.lazy)(() => Promise.resolve().then(() => _interopRequireWildcard(require('./Footer'))).then(module => ({
  default: module.Footer
})));
const FooterLoader = ({
  showFooterAboutSection = false
}) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_logger.ErrorBoundary, {
  areaName: "FooterLoader",
  children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Suspense, {
    fallback: /*#__PURE__*/(0, _jsxRuntime.jsx)(_footer.FooterAppSkeleton, {}),
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(Footer, {
      showFooterAboutSection: showFooterAboutSection
    })
  })
});
exports.FooterLoader = FooterLoader;
